import Client from "../client/ClientSubscription"
const resource = "/api"
const checkView = (data) => {
  return Client.put(`${resource}/can_watch`, data)
}

const getTicket = () => {
  return Client.get(`${resource}/ticket`)
}

const userRepository = {
  checkView,
  getTicket
}

export default userRepository
